import React from 'react';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { useStyles } from './HeaderCardRepo.Styles';

interface HeaderCardRepoProps {
  sessionName: string;
}

export const HeaderCardRepo: React.FC<HeaderCardRepoProps> = ({ sessionName }) => {
  const classes = useStyles();
  const mainHeader = sessionName;
  const { t } = useTranslation();
  useDocumentTitle(t('global:sidebar.sampleAssessmentRepository'));

  return (
    <header className={classes.header}>
      <h1 className={classes.mainHeader}>Repozytorium RGZ: {mainHeader}</h1>
    </header>
  );
};
